import React, { createContext, useState } from 'react';

export interface IPublicShowGlowContext {
  showGlow: boolean;
  setShowGlow: (state: boolean) => void;
}

export const PublicShowGlowContext = createContext(
  {} as IPublicShowGlowContext
);

export function PublicShowGlowProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [showGlow, setShowGlow] = useState<boolean>(false);

  return (
    <PublicShowGlowContext.Provider value={{ showGlow, setShowGlow }}>
      {children}
    </PublicShowGlowContext.Provider>
  );
}
